import axios from "axios";

const HOST = process.env.REACT_APP_HOST;

const getAdmins = async (token: string) => {
  const getAdminsURL = `${HOST}/api/admins`;
  const config = {
    headers: { Authorization: token }
  }

  const res = await axios.get(getAdminsURL, config);

  return res.data;
};

const addAdmin = async (payload: any, token: string) => {
  const newAdminURL = `${HOST}/api/auth/register/admin`;
  const config = {
    headers: { Authorization: token }
  }
  const res = await axios.post(newAdminURL, payload, config);

  return res.data;
};

export { getAdmins, addAdmin }